/*Collection 상단 mobile hash 영역 노출/미노출 */

  var col_hastag = $('.hashtag').text();
  var col_desc = $('.title_desc').text();
  if(col_hastag != ''){
    $('.collection-hero__title').before("<p class='collection_hastag'>"+col_hastag+"</p>");
    $('.collection-hero__description').after('<span class="more_btn">もっと見る</span>');
    
    $('.more_btn').click(function(){
      if($(this).hasClass('on')){
        $(this).removeClass('on');
        $('.collection-hero__description').removeClass('on');
        $(this).text('もっと見る');
      }else{
        $(this).addClass('on');
        $(this).text('隠す');
        $('.collection-hero__description').addClass('on');
      }
    });
  }

   if($('.collection-hero__description').find('.collection_bnrs').length > 0){
    $('.collection-hero__description').addClass('device');
      $('.collection-hero__description').parents('.collection-hero__text-wrapper').addClass('device');
    }

  var col_top_img = $('.collection-hero__description > img').length;
  if(col_top_img != 0){
    $('.collection-hero__description').css('height','auto');
  }

  if (!$('.collection-hero__description').find('p').length) {
    $('.collection-hero__description').css('height','auto');
    $('.collection-hero__title').addClass('on');                                                          
  }
    var cur_url = $(location).attr('href');  
  console.log(cur_url);
   var click_url ='';
  $('.mo_collection_gnb li a').each(function(){
     click_url = $(this).attr('href');  
    if(cur_url == click_url){
      $(this).addClass('on')
    }if(cur_url == 'https://themedicube.jp/collections/%E7%BE%8E%E9%A1%94%E5%99%A8-collection-test'){
      $('.collection_top .SectionHeader').addClass('on');
      $('.CollectionMain').addClass('on');
    }else{
    }
  });